import logo from "assets/images/brands/nexum-capitals-logo.png";
import sideLogo from "assets/images/brands/nexum-200x200.svg";
import smallLogo from "assets/images/brands/nexum-icon.png";

export const clientName = "Nexum Capitals";
export const developedBy = "Nexum Capitals";
export const imagesUrl = process.env.REACT_APP_API_IMAGES_URL;
export const cpUrl = process.env.REACT_APP_CP_URL;
export const apiUrl = process.env.REACT_APP_API_CP_DOMAIN;
export const companyName =  "Nexum Capitals";
export const companyWebsite = "#";
export const privacyPolicyLink = "#";
export const clientAgreementLink = "#";
export const sidebarLogo = sideLogo;
export const smLogo = smallLogo;
export const mainLogo = logo;
export const footerLogo = sideLogo;
